import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=40b3d071&scoped=true&"
import script from "./ingredients.vue?vue&type=script&lang=js&"
export * from "./ingredients.vue?vue&type=script&lang=js&"
import style0 from "./ingredients.vue?vue&type=style&index=0&id=40b3d071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3d071",
  null
  
)

export default component.exports